<template>
	<v-container fluid>
		<div class="d-flex justify-center">
			<div class="login-image mt-3">
				<img src="../assets/logo.png" class="login-image-content">
			</div>
		</div>
		<div v-if="resetPasswd">
			<div class="mt-3" v-bind:class="classRow">
				<div v-bind:class="classInputGroup">
					<div v-bind:class="classInputLabel">
						ユーザID
					</div>
					<v-text-field
						v-model="id"
						maxlength="20"
						counter
						readonly
						v-on:keypress.enter="focusResetPasswd"
						tabindex="1"
						ref="reset_id"
					></v-text-field>
				</div>
			</div>
			<div class="mt-3" v-bind:class="classRow">
				<div v-bind:class="classInputGroup">
					<div v-bind:class="classInputLabel">
						パスワード
					</div>
					<v-text-field 
						v-model="passwd"
						:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
						:type="show_passwd ? 'text' : 'password'"
						@click:append="show_passwd = !show_passwd"
						maxlength="20"
						:rules="[rules.required, rules.validate, rules.length]"
						counter
						v-on:keypress.enter="focusResetConfirm"
						tabindex="2"
						ref="reset_passwd"
					></v-text-field>
				</div>
			</div>
			<div class="mt-3" v-bind:class="classRow">
				<div v-bind:class="classInputGroup">
					<div v-bind:class="classInputLabel">
						パスワード<br v-if="!viewportExtraSmall">(確認)
					</div>
					<v-text-field 
						v-model="confirm_passwd"
						:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
						:type="show_passwd ? 'text' : 'password'"
						@click:append="show_passwd = !show_passwd"
						maxlength="20"
						:rules="[rules.required, rules.validate, rules.length]"
						counter
						v-on:keypress.enter="onClickResetPassword"
						tabindex="3"
						ref="reset_confirm"
					></v-text-field>
				</div>
			</div>
			<div class="login-error mt-3">{{ error }}</div>
			<div class="login-btn mt-3">
				<v-btn 
					flat
					large
					color="white"
					class="primary login-btn-size"
					v-on:click="onClickResetPassword"
					tabindex="4"
				>
					再設定
				</v-btn>
			</div>
			<div class="link-center mt-3">
				<span class="back-login" v-on:click="reset" tabindex="5">
					ログインページへ戻る
				</span>
			</div>
		</div>
		<div v-else>
			<div class="mt-3" v-bind:class="classRow">
				<div v-bind:class="classInputGroup">
					<div v-bind:class="classInputLabel">
						ユーザID
					</div>
					<v-text-field
						v-model="id"
						maxlength="20"
						:rules="[rules.required, rules.validate]"
						counter
						v-on:keypress.enter="focusLoginPasswd"
						tabindex="1"
						ref="login_id"
					></v-text-field>
				</div>
			</div>
			<div class="mt-3" v-bind:class="classRow">
				<div v-bind:class="classInputGroup">
					<div v-bind:class="classInputLabel">
						パスワード
					</div>
					<v-text-field 
						v-model="passwd"
						:append-icon="show_passwd ? 'visibility' : 'visibility_off'"
						:type="show_passwd ? 'text' : 'password'"
						@click:append="show_passwd = !show_passwd"
						maxlength="20"
						:rules="[rules.required, rules.validate]"
						counter
						v-on:keypress.enter="onClickLogin"
						tabindex="2"
						ref="login_passwd"
					></v-text-field>
				</div>
			</div>
			<div class="login-error mt-3">{{ error }}</div>
			<div class="login-btn mt-3">
				<v-btn 
					flat 
					large
					color="white"
					class="primary login-btn-size"
					v-on:click="onClickLogin"
					tabindex="4"
				>
					ログイン
				</v-btn>
			</div>
			<div class="link-center mt-3">
				<router-link class="text-decoration-none" :to="toSignUp" tabindex="5">
					新規登録
				</router-link>
			</div>
		</div>
	</v-container>
</template>
<script>
import TokenManager from '../classes/TokenManager';
import Notification from '../classes/Notification';
import {PERMISSION} from '../data/Const';
import Util from '../classes/Util';

import axios from 'axios';

const validateLength = function(value) {
	if(value.length >=6 && 20 >= value.length)
		return true;
	return false;
};

export default {
	name: 'Login',
	data () {
		return {
			show_passwd: false,
			rules: {
				required: v => !!v || '入力してください',
				validate: v => Util.isValidCharPassword(v) || '無効な文字が含まれています',
				length: v => validateLength(v) || '6文字以上20文字以下で入力してください',
			},
			id: '',
			passwd: '',
			confirm_passwd: '',
			error: '',
			reset_passwd: false,
			dataset_manager: this.$store.getters.datasetManager,
		}
	},
	methods: {
		onClickLogin: function() {
			this.$nextTick(() => {
				Object.keys(this.form).forEach(f => {
					this.$refs[f].validate(true);
				});
			});
			if(!this.id || !this.passwd){
				this.error = 'ID・パスワードを入力してください';
				return false;
			}else if(!Util.isValidCharPassword(this.id) || !Util.isValidCharPassword(this.passwd)){
				this.passwd = '';
				this.error = '入力値が無効です';
				return false;
			}else if(!validateLength(this.id) || !validateLength(this.passwd)) {
				this.error = 'ID, パスワードは6文字以上20文字以下で入力してください';
				this.passwd = '';
				return false;
			}else{
				this.error = '';
			}
			const params = new URLSearchParams();
			params.append('id', this.id);
			params.append('passwd', this.passwd);
			params.append('contractor_id', this.$route.params.contractor_id);
			axios
				.post('/auth', params)
				.then((response) => {
					this.$store.dispatch('setToken', {
						'access_token': TokenManager.decode(response.data.access_token.token),
						'refresh_token': TokenManager.decode(response.data.refresh_token.token),
					}).then(() => {
						let access_token = this.$store.getters.accessToken;
						if (!(access_token.pms)) {
							this.$store.dispatch('logout');
							this.$store.dispatch('addNotification', Notification.error('権限がありません', 'notificationLogin'));
						} else {
							if (access_token.pms & (PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER)) {
								this.$router.push({
									name: 'GanttBoard', 
									params: { 'contractor_id': access_token.iss },
								});
							} else if (access_token.pms & PERMISSION.TYPE.WORKER) {
								this.$router.push({
									name: 'MemberSchedule', 
									params: { 
										'contractor_id': access_token.iss, 
										'id': access_token.sub ,
									},
								});
							}else{
								this.$router.push({
									name: 'GanttBoard', 
									params: { 'contractor_id': access_token.iss },
								});
							}
							this.$store.dispatch('addNotification', Notification.info('ログインに成功しました', 'notificationLogin'));
						}
					});
				})
				.catch((e) => {
					let notification = null;
					this.passwd = '';
					switch(e.response.status) {
						case 400: 
							this.error = 'IDもしくはパスワードが間違っています';
							break;
						case 403: 
							this.error = 'パスワードが無効です. 再設定してください';
							this.$store.commit('updateDataSetID', e.response.data.dataset_id);
							this.reset_passwd = true;
							break;
						case 500: 
							notification = Notification.error('情報の取得に失敗しました', 'notificationLogin');
							break;
						case 504: 
							notification = Notification.error('タイムアウトしました', 'notificationCreateData');
							break;
						default : 
							notification = Notification.error('通信に失敗しました', 'notificationLogin');
							break;
					}
					if(notification)
						this.$store.dispatch('addNotification', notification);
				});
		},
		focusResetPasswd: function() {
			this.$refs.reset_passwd.focus();
		},
		focusResetConfirm: function() {
			this.$refs.reset_confirm.focus();
		},
		focusLoginPasswd: function() {
			this.$refs.login_passwd.focus();
		},
		reset: function() {
			Object.keys(this.form).forEach(f => {
				this.$refs[f].reset();
			});
			this.reset_passwd = false;
			this.id = '';
			this.passwd = '';
			this.confirm_passwd = '';
			this.error = '';
		},
		onClickResetPassword: function() {
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
			if(!this.passwd || !this.confirm_passwd){
				this.error = 'パスワードを入力してください';
				return false;
			}else if(!Util.isValidCharPassword(this.passwd)){
				this.error = '入力値が無効です';
				this.passwd = '';
				this.confirm_passwd = '';
				return false;
			}else if(!validateLength(this.passwd)) {
				this.error = 'パスワードは6文字以上20文字以下で入力してください';
				this.passwd = '';
				this.confirm_passwd = '';
				return false;
			}else if(this.passwd !== this.confirm_passwd) {
				this.error = 'パスワードと確認用パスワードが一致しません';
				this.passwd = '';
				this.confirm_passwd = '';
				return false;
			}else{
				this.error = '';
			}
			const params = new URLSearchParams();
			params.append('id', this.id);
			params.append('passwd', this.passwd);
			params.append('contractor_id', this.$route.params.contractor_id);
			params.append('dataset_id', this.$store.getters.datasetID);
			axios
				.post('/auth/reset_passwd', params)
				.then((response) => {
					this.reset_passwd = false;
					this.$store.commit('updateDataSetID', response.data.dataset_id);
					this.error = '';
					this.$store.dispatch('addNotification', Notification.info('パスワードを変更しました', 'notificationCreateData'));
					this.onClickLogin();
				})
				.catch((e) => {
					let notification = null;
					this.passwd = '';
					this.confirm_passwd = '';
					switch(e.response.status) {
						case 400: this.error = '入力値が無効です';													break;
						case 500: notification = Notification.error('パスワードの変更に失敗しました', 'notificationLogin');	break;
						case 504: notification = Notification.error('タイムアウトしました', 'notificationCreateData');	break;
						default : notification = Notification.error('通信に失敗しました', 'notificationLogin');		break;
					}
					if(notification)
						this.$store.dispatch('addNotification', notification);
				});
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
	},
	computed: {
		resetPasswd: function() {
			return this.reset_passwd;
		},
		toSignUp: function() {
			return {
				name: 'SignUp',
				params: { 
					'contractor_id': this.$route.params.contractor_id,
				},
			};
		},
		viewportExtraSmall: function() {
			let width = this.$store.getters.width;
			if(!width)
				this.onWindowResize();
			return width < 600;
		},
		classRow: function() {
			if (!this.viewportExtraSmall)
				return ['d-flex', 'justify-center'];
			return '';
		},
		classInputGroup: function() {
			if (!this.viewportExtraSmall)
				return ['login-input-group'];
			return '';
		},
		classInputLabel: function() {
			if (!this.viewportExtraSmall)
				return ['login-input-label'];
			return '';
		},
		form: function() {
			if(this.resetPasswd)
				return {
					reset_id: this.id,
					reset_passwd: this.passwd,
					reset_confirm: this.confirm_passwd,
				};
			else
				return {
					login_id: this.id,
					login_passwd: this.passwd,
				};
		},
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
	},
}
</script>
<style>
	.login-image {
		display: flex;
		justify-content: center;
		max-width: 300px;
	}
	.login-image-content {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		/*border-radius: 50%;*/
	}
	.login-input-group {
		position: relative;
		max-width: 275px;
	}
	.login-input-label {
		position: absolute;
		top: 25px;
		left: -80px;
		margin-right: 16px;
	}
	.login-btn {
		display: flex;
		justify-content: center;	
	}
	.login-btn-size {
		width: 120px;
	}
	.login-error {
		display: flex;
		justify-content: center;
		color: red;
		height: 20px;
	}
	.link-center {
		display: flex;
		justify-content: center;
	}
	.text-decoration-none {
		text-decoration: none;
	}
	.back-login {
		color: #1976d2;
		cursor: pointer;
		outline: none;
	}
</style>
